module.exports = __webpack_public_path__ + "static/img/communication.70fbc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subtitle/communication.png
// module id = b0jd
// module chunks = 1